import React, { useEffect, useState } from "react";
import { X } from "lucide-react";
import { useAPI } from "../Context/MyContext";
import { FaExternalLinkAlt, FaPhoneAlt, FaReply, FaWhatsapp } from "react-icons/fa";

export const TemplateModal = ({ template, isOpen, onClose, phone_number_id }) => {
  const [mediaSrc, setMediaSrc] = useState(null);
  const { GetMediaUrlForTemplate } = useAPI();


  console.log("TemplateModal Rendered with template:", template, "and phone_number_id:", phone_number_id);

  const templateName = template?.name || "";

  const headerComponent = template?.components?.find((c) => c.type === "HEADER");
  const headerType = headerComponent?.format || "None";
  useEffect(() => {
    const fetchMedia = async () => {
      if (
        headerType === "IMAGE" || headerType === "VIDEO" || headerType === "DOCUMENT"
        // headerComponent?.parameters?.[0]?.image?.id
      ) {
        try {
          console.log("Fetching media for template:", templateName, "with header component:", headerComponent);
          const url = await GetMediaUrlForTemplate(templateName, phone_number_id);
          console.log("Media URL fetched Result:", url);

          setMediaSrc(url);
        } catch (err) {
          console.error("Media fetch failed:", err);
          setMediaSrc(null);
        }
      } else {
        setMediaSrc(null);
      }
    };

    fetchMedia();
    // }, [templateName, phone_number_id, headerType]);
  }, [isOpen, template, phone_number_id, headerType]);


  if (!isOpen || !template) return null;



  // const headerComponent = template.components?.find((c) => c.type === "HEADER");
  const bodyComponent = template.components?.find((c) => c.type === "BODY");
  const footerComponent = template.components?.find((c) => c.type === "FOOTER");
  const buttonsComponent = template.components?.find((c) => c.type === "BUTTONS");

  // const headerType = headerComponent?.format || "None";
  const headerText = headerComponent?.text || "";
  const bodyText = bodyComponent?.text || "";
  const footerText = footerComponent?.text || "";


  const formatBodyText = (text) => {
    if (!text) return "";
    return text
      .replace(/\*(.*?)\*/g, "<strong>$1</strong>")
      .replace(/\n/g, "<br />");
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 px-4">
      <div className="bg-[#F4F0EC] rounded-2xl shadow-lg p-6 w-full max-w-3xl overflow-y-auto max-h-[90vh] relative">

        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-500 hover:text-red-500"
        >
          <X size={24} />
        </button>

        <h2 className="text-2xl font-semibold text-blue-700 mb-6 text-center">
          Template Preview
        </h2>

        <div
          className="bg-cover bg-center rounded-lg p-4"
          style={{
            backgroundImage:
              "url('https://e0.pxfuel.com/wallpapers/722/149/desktop-wallpaper-message-background-whatsapp-message-background.jpg')",
          }}
        >
          <div className="bg-white p-4 rounded-xl shadow-md max-w-[400px] mx-auto space-y-3">

            {/* Header */}
            {headerType !== "None" && (
              <div className="border-b pb-2">
                {headerType === "TEXT" ? (
                  <p className="font-bold text-gray-900">{headerText}</p>
                ) : headerType === "IMAGE" ? (


                  <>
                    {/* If mediaSrc is available, show the image; otherwise, show a placeholder or message */}
                    {
                      mediaSrc ? (
                        <img
                          src={mediaSrc}
                          alt="Header"
                          className="w-full h-auto rounded-md object-cover"
                          onError={(e) => {
                            e.target.style.display = "none";
                            e.target.nextSibling.style.display = "flex";
                          }}
                        />
                      ) : null
                    }

                    <div
                      className="w-full h-[150px] flex items-center justify-center bg-gray-100 rounded-md text-gray-400 text-sm"
                      style={{ display: mediaSrc ? "none" : "flex" }}
                    >
                      [IMAGE Preview]
                    </div>

                  </>
                ) : (
                  <>

                    {/* For VEDIO OR DOCUMENT */}

                    {
                      headerType === "VIDEO" ? (
                        mediaSrc ? (
                          <video controls className="w-full h-auto rounded-md object-cover">
                            <source src={mediaSrc} type="video/mp4" />
                            Your browser does not support the video tag.
                          </video>
                        ) : (
                          <div

                            className="w-full h-[150px] flex items-center justify-center bg-gray-100 rounded-md text-gray-400 text-sm"
                          >
                            [VIDEO Preview]
                          </div>
                        )
                      ) : (
                        <>
                          {
                            headerType === "DOCUMENT" ? (
                              mediaSrc ? (
                                <div className="w-full border rounded-md p-3 bg-gray-50 flex items-center justify-between">
                                  <div className="text-sm text-gray-700 truncate">
                                    📄 Document Preview
                                  </div>

                                  <a
                                    href={mediaSrc}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-blue-600 text-sm underline"
                                  >
                                    Open
                                  </a>
                                </div>
                              ) : (
                                <div className="w-full h-[150px] flex items-center justify-center bg-gray-100 rounded-md text-gray-400 text-sm">
                                  [DOCUMENT Preview]
                                </div>
                              )
                            ) : null
                          }
                        </>
                      )

                    }

                    {/* <p className="italic text-gray-400 text-sm">
                      [{headerType} Preview]
                    </p> */}

                  </>


                )}
              </div>
            )}

            {/* Body */}
            {bodyText && (
              <div
                className="text-gray-800 text-sm leading-relaxed"
                dangerouslySetInnerHTML={{ __html: formatBodyText(bodyText) }}
              />
            )}

            {/* Footer */}
            {footerText && (
              <p className="text-xs text-gray-500 pt-2 border-t">
                {footerText}
              </p>
            )}

            {/* Buttons */}
            {/* {buttonsComponent?.buttons?.length > 0 && (
              <div className="pt-3 space-y-2 border-t">
                {buttonsComponent.buttons.map((btn, idx) => {
                  const baseClass =
                    "w-full text-sm font-medium px-4 py-2.5 rounded-lg border border-gray-300 flex items-center justify-center";

                  if (btn.type === "QUICK_REPLY") {
                    return (
                      <button key={idx} className={`${baseClass} text-blue-600`}>
                        ↩️ {btn.text}
                      </button>
                    );
                  }

                  if (btn.type === "PHONE_NUMBER") {
                    return (
                      <a key={idx} href={`tel:${btn.phone_number}`} className={`${baseClass} text-green-600`}>
                        📞 {btn.text}
                      </a>
                    );
                  }
                
                  if (btn.type === "URL") {
                    return (
                      <a
                        key={idx}
                        href={btn.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={`${baseClass} text-blue-600`}
                      >
                        🔗 {btn.text}
                      </a>
                    );
                  }

                  return null;
                })}
              </div>
            )} */}


            {buttonsComponent?.buttons?.length > 0 && (
              <div className="pt-4 mt-4 space-y-3 border-t border-gray-200">
                {buttonsComponent.buttons.map((btn, idx) => {
                  const baseClass =
                    "w-full text-sm font-semibold px-4 py-3 rounded-xl border flex items-center justify-center gap-2 transition-all duration-300 shadow-sm hover:shadow-md hover:scale-[1.02]";

                  if (btn.type === "QUICK_REPLY") {
                    return (
                      <button
                        key={idx}
                        className={`${baseClass} bg-blue-50 border-blue-200 text-blue-700 hover:bg-blue-100`}
                      >
                        <FaReply className="text-blue-500 text-base" />
                        {btn.text}
                      </button>
                    );
                  }

                  if (btn.type === "PHONE_NUMBER") {
                    return (
                      <a
                        key={idx}
                        href={`tel:${btn.phone_number}`}
                        className={`${baseClass} bg-green-50 border-green-200 text-green-700 hover:bg-green-100`}
                      >
                        <FaPhoneAlt className="text-green-500 text-base" />
                        {btn.text}
                      </a>
                    );
                  }

                  if (btn.type === "VOICE_CALL") {
                    return (
                      <a
                        key={idx}
                        href={`https://wa.me/${btn.phone_number || ""}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={`${baseClass} bg-emerald-50 border-emerald-200 text-emerald-700 hover:bg-emerald-100`}
                      >
                        <FaWhatsapp className="text-emerald-500 text-lg" />
                        {btn.text}
                      </a>
                    );
                  }

                  if (btn.type === "URL") {
                    return (
                      <a
                        key={idx}
                        href={btn.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={`${baseClass} bg-purple-50 border-purple-200 text-purple-700 hover:bg-purple-100`}
                      >
                        <FaExternalLinkAlt className="text-purple-500 text-sm" />
                        {btn.text}
                      </a>
                    );
                  }

                  return null;
                })}
              </div>
            )}

            <p className="text-xs text-gray-400 text-right mt-2">
              {new Date().toLocaleTimeString("en-US", {
                hour: "2-digit",
                minute: "2-digit",
                hour12: false,
              })}
            </p>

          </div>
        </div>
      </div>
    </div>
  );
};